import { KeyboardEvent } from "react";

import {
  DEFAULT_COUNTRY_CODE,
  EMAIL_REGEX,
  NUMBER_INPUT_REGEX,
  ONLY_CHARACTERS_AND_SPACES_REGEX,
  PHONE_NUMBER_IS_INVALID,
} from "@zenith/data/constants";
import { getPhoneNumberLength } from "@zenith/features/globalUtils";
import { FormFieldErrorType } from "@zenith/types";
import {
  TeamManagementFields,
  TeamManagementFormValidation,
  TeamManagementForm,
  TeamManagementFormType,
} from "../utils/form-fields";

export const NO_ERROR: FormFieldErrorType = {
  message: "",
  hasError: false,
};

export const INITIAL_DATA: TeamManagementFormType = {
  email: "",
  firstName: "",
  lastName: "",
  phoneNumber: "",
};

export const INITIAL_ERROR_DATA: TeamManagementFormValidation = {
  email: NO_ERROR,
  firstName: NO_ERROR,
  lastName: NO_ERROR,
  phoneNumber: NO_ERROR,
};

export const validateFirstName = (value: string): FormFieldErrorType => {
  if (!value) {
    return {
      message: "First name is required",
      hasError: true,
    };
  }

  return NO_ERROR;
};

export const validateLastName = (value: string): FormFieldErrorType => {
  if (!value) {
    return {
      message: "Last name is required",
      hasError: true,
    };
  }

  return NO_ERROR;
};

export const validatePhoneNumber = (value: string): FormFieldErrorType => {
  if (!value) {
    return {
      message: "Phone number is required",
      hasError: true,
    };
  }

  if (value.length < getPhoneNumberLength(DEFAULT_COUNTRY_CODE, value)) {
    return {
      message: PHONE_NUMBER_IS_INVALID,
      hasError: true,
    };
  }
  return NO_ERROR;
};

export const validateEmail = (value: string): FormFieldErrorType => {
  if (!value) {
    return {
      message: "Email address is required",
      hasError: true,
    };
  }

  if (value && !EMAIL_REGEX.test(value)) {
    return {
      message: "Email address not valid",
      hasError: true,
    };
  }
  return NO_ERROR;
};

export const preventSpace = (event: KeyboardEvent<HTMLInputElement>) => {
  const key = event.key;
  if (/\s+/g.test(key)) {
    return event.preventDefault();
  }
};

export const processValue = (field: TeamManagementFields, value: string) => {
  switch (field) {
    case TeamManagementFields.FIRST_NAME:
    case TeamManagementFields.LAST_NAME:
      return value.replace(ONLY_CHARACTERS_AND_SPACES_REGEX, "");
    case TeamManagementFields.PHONE_NUMBER:
      return value.replace(NUMBER_INPUT_REGEX, "");
    case TeamManagementFields.EMAIL:
      return value.split(" ").join("");
    default:
      return value;
  }
};

export const FormHasError = (
  formErrors: TeamManagementFormValidation,
  formData: TeamManagementFormType
) => {
  if (Object.values(formData).some((value) => !value)) return true;

  return Object.values(formErrors).some((error) => error.hasError);
};

export const hasFormChanged = (
  formData: TeamManagementForm,
  defaultFormData: TeamManagementForm
) => {
  return Object.keys(formData).some((k) => {
    const key = k as keyof TeamManagementForm;
    return formData[key] !== defaultFormData[key];
  });
};
